import anchorTeal from "@/assets/anchor-teal.svg";
import anchorBlue from "@/assets/anchor-blue.svg";

interface AnchorIconProps {
  className?: string;
  variant?: "teal" | "blue";
}

export const AnchorIcon = ({ className, variant = "teal" }: AnchorIconProps) => {
  const src = variant === "blue" ? anchorBlue : anchorTeal;
  
  return (
    <img 
      src={src} 
      alt="HostCaptain" 
      className={className}
    />
  );
};
